import React from 'react';

type StatusIndicatorProps = {
  isSuccess: number | boolean | null | undefined;
};

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ isSuccess }) => {
  return (
    <div className='inline'>
      {isSuccess ? (
        <span style={{ color: 'green' }}>&#10004;</span> // Green checkmark
      ) : (
        <span style={{ color: 'red' }}>&#10006;</span> // Red x mark
      )}
    </div>
  );
};

export default StatusIndicator;
